import { Box, IconNew as Icon, Text, TextInput, TextNew } from '@jfs/ui-new'
import { useEffect, useRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'
import { MobileNumberreg } from '../../util/regex'
import { ModBox } from '../ModifiedBox/ModifiedBox'

const leftComponent = () => (
  <Box>
    <Text color="CLOUDY_GREY" type="h2">
      {'+91'}
    </Text>
  </Box>
)

export const ForgotPasswordTextInput = (props: any) => {
  const inputTextField = useRef<RNTextInput>(null)

  const mobileNum = props?.value ?? ''
  const isMobileNumberAvailable = mobileNum?.length > 9

  const label = props?.label
  const maxLength = props?.maxLength
  const fieldName = props?.fieldName
  const placeholder = props?.placeholder
  const keyboardType = props?.keyboardType
  const returnKeyType = props?.returnKeyType
  const setFieldValue = props?.setFieldValue

  const [textInputVal, updateTextInputVal] = useState(mobileNum)
  const [error, setError] = useState('')
  const [isTFEditable, makeTFEditable] = useState(isMobileNumberAvailable ? false : true)

  const onChange = (val: string) => {
    updateTextInputVal(val)
    setFieldValue(fieldName, val)
    setError('')
  }

  const onRightButtonClosePress = () => {
    updateTextInputVal('')
    setFieldValue(fieldName, '')
    setError('')
  }

  const rightComponent = () => {
    return (
      <ModBox
        show={textInputVal?.length > 0 && isTFEditable}
        justify="center"
        ph={10}
        underlayColor="WHITE"
        testID="onRightButtonClosePress"
        onPress={onRightButtonClosePress}>
        <Icon id="CLOSE" size={18} color="BLUE" />
      </ModBox>
    )
  }

  const toggleEditibility = () => {
    makeTFEditable(!isTFEditable)
  }

  const rightComponentEdit = () => {
    return (
      <ModBox show={!isTFEditable} justify="center" underlayColor="WHITE" onPress={toggleEditibility}>
        <TextNew type="body12" weight="dense" color="BLUE">
          {'Edit'}
        </TextNew>
      </ModBox>
    )
  }

  const onBlur = () => {
    if (textInputVal?.length < 10) {
      setError('Please enter 10 digit mobile number!')
    } else if (MobileNumberreg?.test(textInputVal) !== true) {
      setError('Please enter valid mobile number!')
    }
  }

  useEffect(() => {
    inputTextField?.current?.blur()
    setTimeout(() => {
      inputTextField?.current?.focus()
    }, 200)
  }, [isTFEditable, inputTextField])

  const showError = error !== '' && textInputVal > 0

  return (
    <>
      <TextInput
        placeholder={placeholder}
        value={textInputVal}
        onChangeText={onChange}
        maxLength={maxLength}
        keyboardType={keyboardType}
        label={label}
        editable={isTFEditable}
        autoFocus={isTFEditable}
        onFocusBottomLineColor={'BLUE'}
        color="BLACK_75"
        onFocus={() => setError('')}
        innerRef={inputTextField}
        bottomLineColor={!showError ? 'TRANSPARENT' : 'ERROR'}
        error={props?.error}
        returnKeyType={returnKeyType}
        rightComponent={isTFEditable ? rightComponent() : rightComponentEdit()}
        leftComponent={leftComponent()}
        onBlur={onBlur}
      />
      <ModBox pt={5} show={showError}>
        <TextNew type="body12" color="ERROR">
          {error}
        </TextNew>
      </ModBox>
    </>
  )
}

export default { ForgotPasswordTextInput }
